'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseFleetInsightSubViewController=require('../../../../../dist-es6/client/features/fleetInsight/components/baseFleetInsightSubViewController');let

FatigueTrendsDirective=function(_BaseControllerBacked){_inherits(FatigueTrendsDirective,_BaseControllerBacked);function FatigueTrendsDirective(){_classCallCheck(this,FatigueTrendsDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(FatigueTrendsDirective,[{key:'templateUrl',get:function()
{
return'/templates/features/fleetInsight/components/fatigueTrendsTemplate';
}},{key:'objectBindings',get:function()

{
return['displayInterval'];
}},{key:'controller',get:function()

{
return FatigueTrendsDirectiveController;
}},{key:'$inject',get:function()

{
return[
'$timeout',
'$state',
'$scope',
'fatigueTrendsDataService',
'uncaughtErrorHandler',
'groupTreeService'];

}}]);return FatigueTrendsDirective}(BaseControllerBackedDirective);let


FatigueTrendsDirectiveController=function(_BaseFleetInsightSubV){_inherits(FatigueTrendsDirectiveController,_BaseFleetInsightSubV);
function FatigueTrendsDirectiveController($timeout,$state,$scope,fatigueTrendsDataService,uncaughtErrorHandler,groupTreeService){_classCallCheck(this,FatigueTrendsDirectiveController);return _possibleConstructorReturn(this,
_BaseFleetInsightSubV.call(this,$state,$scope,fatigueTrendsDataService,uncaughtErrorHandler,groupTreeService));
}return FatigueTrendsDirectiveController}(BaseFleetInsightSubViewController);


module.exports=FatigueTrendsDirective;
//# sourceMappingURL=fatigueTrendsDirective.js.map
